import { render, staticRenderFns } from "./PeringkatPenelitiKeamanan.vue?vue&type=template&id=68814c50&scoped=true&"
import script from "./PeringkatPenelitiKeamanan.vue?vue&type=script&lang=js&"
export * from "./PeringkatPenelitiKeamanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68814c50",
  null
  
)

export default component.exports